import { get } from 'lodash-es';

import {
  GENERATE_DRAFT_LINKS,
  CLEAR_DRAFT_LINKS,
  GET_DRAFT_LINKS,
} from 'modules/v2/draft/store/constants';
import { STATUS_SUCCESS, STATUS_ERROR, STATUS_LOADING } from 'store/status';

import { links as initialState } from 'modules/v2/draft/store/reducers/initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GENERATE_DRAFT_LINKS}_REQUESTED`:
    case `${GET_DRAFT_LINKS}_REQUESTED`: {
      return {
        ...state,
        data: null,
        status: STATUS_LOADING,
      };
    }

    case `${GENERATE_DRAFT_LINKS}_FAILED`:
    case `${GET_DRAFT_LINKS}_FAILED`: {
      return {
        ...state,
        status: STATUS_ERROR,
      };
    }

    case `${GENERATE_DRAFT_LINKS}_SUCCEEDED`:
    case `${GET_DRAFT_LINKS}_SUCCEEDED`: {
      const data = get(action, ['payload'], null);

      return {
        ...state,
        data,
        status: STATUS_SUCCESS,
      };
    }

    case CLEAR_DRAFT_LINKS: {
      return { ...initialState };
    }

    default:
      return state;
  }
};

export default reducer;
